// extracted by mini-css-extract-plugin
module.exports = {"SkipToContent":"_23GYb"};